import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import userApi from "@/lib/userApi";
import { formatApiErrorDetail } from "@/lib/api";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Паролата трябва да е поне 6 символа."); return; }
    if (pw !== pw2) { toast.error("Паролите не съвпадат."); return; }
    setBusy(true);
    try {
      await userApi.post("/account/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Паролата е сменена.");
      setTimeout(() => navigate("/vhod"), 1800);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const inputClass =
    "w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-primary focus:ring-2 focus:ring-primary/20";

  return (
    <Layout showTicker={false}>
      <Seo title="Нова парола" noindex />
      <div className="mx-auto max-w-md px-4 py-16" data-testid="reset-password-page">
        {!token ? (
          <div className="text-center text-slate-600">Липсва код за нулиране. Заявете нова връзка от <Link to="/zabravena-parola" className="text-primary hover:underline">тук</Link>.</div>
        ) : done ? (
          <div className="text-center" data-testid="reset-done">
            <CheckCircle2 className="mx-auto h-14 w-14 text-green-600" />
            <h1 className="mt-5 font-display text-2xl font-extrabold text-slate-900">Готово!</h1>
            <p className="mt-2 text-slate-600">Паролата е сменена. Пренасочваме Ви към вход…</p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-2xl font-extrabold text-slate-900">Задайте нова парола</h1>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
              <input type="password" className={inputClass} data-testid="reset-password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Нова парола (поне 6 символа)" />
              <input type="password" className={inputClass} data-testid="reset-password2" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Повторете паролата" />
              <button type="submit" disabled={busy} data-testid="reset-submit" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-[#0041A8] disabled:opacity-60">
                {busy && <Loader2 className="h-5 w-5 animate-spin" />}Смени паролата
              </button>
            </form>
          </>
        )}
      </div>
    </Layout>
  );
}
